export type CommunityHistoryCreateMode = 'historical' | 'operational' | 'blocked' | 'duplicate';

export function resolveCommunityHistoryCreateMode(
  validFrom: string,
  currentValidFrom?: string | null,
): CommunityHistoryCreateMode {
  if (!currentValidFrom) {
    return 'blocked';
  }

  if (validFrom === currentValidFrom) {
    return 'duplicate';
  }

  return validFrom < currentValidFrom ? 'historical' : 'operational';
}
